import React from 'react';
import PropTypes from 'prop-types';

import V3MobileBottomSheet from './V3MobileBottomSheet';
import V3PerformerPicker from '../V3PerformerPicker';

// Mobile presentation of the shared artist picker — drops V3PerformerPicker
// into the bottom-sheet shell. The "Change artist" desktop modal renders the
// same V3PerformerPicker inside a centered popup instead.
const V3MobilePerformerPickerSheet = ({
  open,
  onClose,
  currentPerformer,
  mode,
  onSubmit,
  teamId,
}) => (
  <V3MobileBottomSheet open={open} onClose={onClose}>
    <V3PerformerPicker
      currentPerformer={currentPerformer}
      mode={mode}
      allowTba
      onSubmit={onSubmit}
      onClose={onClose}
      variant="sheet"
      teamId={teamId}
    />
  </V3MobileBottomSheet>
);

V3MobilePerformerPickerSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentPerformer: PropTypes.shape({
    id: PropTypes.number,
    act_type: PropTypes.string,
    name: PropTypes.string,
    artistable: PropTypes.shape({ name: PropTypes.string }),
  }),
  mode: PropTypes.oneOf(['edit', 'add-sibling']).isRequired,
  onSubmit: PropTypes.func.isRequired,
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

V3MobilePerformerPickerSheet.defaultProps = {
  currentPerformer: null,
  teamId: null,
};

export default V3MobilePerformerPickerSheet;
